import { render, staticRenderFns } from "./CartasSite.vue?vue&type=template&id=d6cf5daa&"
import script from "./CartasSite.vue?vue&type=script&lang=js&"
export * from "./CartasSite.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports